import {
  SELECTABLE_UI_LANGUAGE_CODES,
  normalizeUiLanguageCode,
} from '../constants/uiLanguages';
import { getPathBoundUiLanguage } from '../lib/uiRouteLanguage';

const EXTERNAL_PROTOCOL_PATTERN = /^[a-z][a-z\d+.-]*:/i;

export function getLocalizedRouteLanguage(pathname, fallbackLanguage = 'en') {
  const normalizedFallback = normalizeUiLanguageCode(fallbackLanguage);
  const pathBoundLanguage = getPathBoundUiLanguage(pathname);

  return pathBoundLanguage
    ? normalizeUiLanguageCode(pathBoundLanguage, normalizedFallback)
    : normalizedFallback;
}

export function stripLocalizedRoutePrefix(pathname = '/') {
  const normalizedPath = String(pathname || '/').startsWith('/')
    ? String(pathname || '/')
    : `/${pathname || ''}`;
  const segments = normalizedPath.split('/');
  const firstSegment = String(segments[1] || '');
  const hasLanguagePrefix = SELECTABLE_UI_LANGUAGE_CODES.some(
    (code) => code.toLowerCase() === firstSegment.toLowerCase()
  );

  if (!hasLanguagePrefix) {
    return normalizedPath;
  }

  const stripped = `/${segments.slice(2).join('/')}`;
  return stripped === '/' ? '/' : stripped.replace(/\/{2,}/g, '/');
}

export function buildLocalizedPath(path, languageCode) {
  if (typeof path !== 'string' || path.length === 0) {
    return path;
  }

  if (
    path.startsWith('#')
    || path.startsWith('//')
    || EXTERNAL_PROTOCOL_PATTERN.test(path)
  ) {
    return path;
  }

  const normalizedLanguage = normalizeUiLanguageCode(languageCode);
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const pathWithoutLanguage = stripLocalizedRoutePrefix(normalizedPath);

  return pathWithoutLanguage === '/'
    ? `/${normalizedLanguage}`
    : `/${normalizedLanguage}${pathWithoutLanguage}`;
}
